export default __webpack_public_path__ + "static/media/icon-user-group-white.f5034837.svg";